import { useTeamSetupAreasContextRequired } from './TeamSetupAreasContext';

export function useSetupAreaRequiredButtonsHelper() {
  const teamSetupAreasContext = useTeamSetupAreasContextRequired();

  const isDisabled = teamSetupAreasContext.teamSetupAreas.length === 0;

  const title = isDisabled ? "You need to set up at least one market or process before continuing" : undefined;

  return {
    isDisabled,
    title,
  }
}
